import React from 'react';

import { Toggle } from '@auspost/postmaster-react';

import RowContent, { RowContentProps } from '../RowContent/RowContent';

import styles from './ToggleRow.module.scss';

interface ToggleRowProps extends RowContentProps, React.HTMLAttributes<HTMLDivElement> {
  isToggled?: boolean;
}

const ToggleRow: React.FC<ToggleRowProps> = ({ icon, text, isToggled, ...props }) => {
  return (
    <div className={styles.toggleRow} {...props}>
      <RowContent icon={icon} text={text}></RowContent>
      <Toggle id='toggle' isToggled={isToggled} readOnly />
    </div>
  );
};

export default ToggleRow;
